// extracted by mini-css-extract-plugin
module.exports = {"container":"RiskModal_container__3FS-e","header":"RiskModal_header__1rf_a","lists":"RiskModal_lists__3m_9B","footerSection":"RiskModal_footerSection__12htT"};